import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Loading from 'react-loading';
import { Form } from 'semantic-ui-react';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { useMutation } from '@apollo/react-hooks';
import { Main, Button, Send } from './styles';
import { MdSend } from 'react-icons/md';
import { toast } from 'react-toastify';
import { Popup } from 'semantic-ui-react';

import {
  ADD_EXCLUSION_RULE,
  UPDATE_EXCLUSION_RULE
} from '../../../services/graphql/mutations';

import { schema, formInitialState, formErrorInitialState } from './constants';

export default function Modal({
  edit,
  onClose,
  selectedValue,
  open,
  malls,
  countries,
  selected = {}
}) {
  const [{ country, mall, rule, rule_type, active }, setFormState] = useState(
    formInitialState
  );
  const [
    { countryError, mallError, ruleError, rule_typeError, activeError },
    setFormErrorState
  ] = useState(formErrorInitialState);

  const [addExclusionRule, { loading: addLoading }] = useMutation(
    ADD_EXCLUSION_RULE
  );
  const [updateExclusionRule, { loading: updateLoading }] = useMutation(
    UPDATE_EXCLUSION_RULE
  );

  useEffect(() => {
    if (open) {
      setFormState(formInitialState);
      setFormErrorState(formErrorInitialState);
    }

    if (edit && open) {
      const { country_id, mall_id, rule, rule_type, active } = selected;

      setFormState({
        country: country_id,
        mall: mall_id,
        rule,
        rule_type,
        active
      });
    }
  }, [open, edit, selected]);

  function handleOnChange(name, value) {
    setFormState(prevState => ({ ...prevState, [name]: value }));
  }

  async function handleSubmit() {
    try {
      setFormErrorState(formErrorInitialState);

      await schema.validate(
        { country, mall, rule, rule_type, active },
        { abortEarly: false }
      );

      if (edit) {
        const editExclusionRuleInput = {
          id: selected.id,
          country_id: country,
          mall_id: mall,
          rule,
          rule_type,
          active
        };

        await updateExclusionRule({
          variables: {
            editExclusionRuleInput
          }
        });
      } else {
        const exclusionRuleInput = {
          country_id: country,
          mall_id: mall,
          rule,
          rule_type,
          active
        };

        await addExclusionRule({
          variables: {
            exclusionRuleInput
          }
        });
      }

      setFormState(formInitialState);

      let successMessage;

      if (edit) successMessage = 'El registro fue editado exitosamente';
      else successMessage = 'El registro fue creado exitosamente';

      toast.success(successMessage);

      handleClose();
    } catch (err) {
      if (err.inner) {
        err.inner.map(error =>
          setFormErrorState(prevState => ({
            ...prevState,
            [`${error.path}Error`]: true
          }))
        );
      } else {
        let errorMessage;

        if (edit) errorMessage = 'Error al intentar actualizar el registro';
        else errorMessage = 'Error al intentar crear el registro';

        toast.error(errorMessage);
      }
    }
  }

  function handleClose() {
    onClose(selectedValue);
  }

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">
        {edit ? 'Editar' : 'Ingresar'} Lista de Exclusión
      </DialogTitle>
      <Main data-testid="modal-component">
        <Form>
          <Form.Group>
          <Popup
              mouseEnterDelay={500}
              mouseLeaveDelay={200}
              content="Seleccione el tipo de regla"
              trigger={
                <Form.Select
                    error={rule_typeError}
                    label="Tipo de regla *"
                    placeholder="Tipo de regla"
                    options={[
                      {
                        value: 1,
                        text: 'Literal'
                      },
                      {
                        value: 2,
                        text: 'Expresion Regular'
                      }
                    ]}
                    width={12}
                    value={rule_type}
                    onChange={(e, { value }) => handleOnChange('rule_type', value)}
                  />
              }
          />
          <Popup
              mouseEnterDelay={500}
              mouseLeaveDelay={200}
              content="Ingrese la patente ej: XXXX12 si tipo de regla es Literal o una expresion regular ej: /ab+c/ si tipo de regla es Expresion Regular"
              trigger={
                <Form.Input
                  error={ruleError}
                  label="Regla *"
                  placeholder="Regla"
                  width={12}
                  value={rule}
                  onChange={(e, { value }) => handleOnChange('rule', value)}
                  className="plateInput"
                />
              }
          />  
          </Form.Group>
          <Form.Group>
            <Form.Select
              error={mallError}
              label="Centro Comercial *"
              placeholder="Centro Comercial"
              options={malls}
              width={4}
              value={mall}
              onChange={(e, { value }) => handleOnChange('mall', value)}
            />
            <Form.Select
              error={countryError}
              label="País *"
              placeholder="País"
              options={countries}
              width={4}
              value={country}
              onChange={(e, { value }) => handleOnChange('country', value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Checkbox
              error={activeError}
              label="Activo"
              width={2}
              onClick={() => handleOnChange('active', !active)}
              checked={active}
            />
          </Form.Group>
        </Form>
        <Button onClick={handleSubmit} data-testid="send-button">
          {addLoading || updateLoading ? (
            <Loading height={15} width={15} type="spin" />
          ) : (
            <Send>
              <MdSend />
              Enviar
            </Send>
          )}
        </Button>
      </Main>
    </Dialog>
  );
}

Modal.propTypes = {
  edit: PropTypes.bool,
  onClose: PropTypes.func,
  selectedValue: PropTypes.any,
  open: PropTypes.bool,
  selected: PropTypes.object,
  malls: PropTypes.array,
  countries: PropTypes.array
};
